var moment = require("moment");

export var DIGITAL_EXERCISES = "digital-exercises";
export var LOG_READING = "log-reading";
export var INVITE_SPONSORS = "invite-sponsors";
export var AUTOGRADER_DATA = "autograder-data";
export var TEACHER_COMMENTS = "teacher-comments";
export var TEXT_SPECIFIC_QUESTIONS = "text-specific-questions";
export var CLOZE_ASSESSMENTS = "cloze-assessments";
export var HISTORICAL_DATA = "historical-data";
export var LEARNING_SERIES = "learning-series";
export var AUTOGRADED_ANSWERS = "autograded-answers";
export var STUDENT_DIFFERENTIATION = "student-differentiating"; // Spelling error :(
export var STANDARDS_CUSTOMIZATION = "standards-customization";
export var GROUP_INSIGHTS = "group-insights";
export var TASK_ITEMS = "task-items";

export function isEnabled(feature, forUser) {
	if (forUser === undefined) {
		// Require here to avoid circular dependencies
		var CurrentUser = require("lib/account/CurrentUser");
		forUser = CurrentUser.get();
	}

	if (!_.includes(ALL_FEATURES, feature)) {
		console.error("Unrecognized feature " + feature);
	}

	if (forUser && forUser.account) {
		return forUser.account.features[feature];
	}
}

export function anyDisabled(features) {
	return _.any(features, (feature) => { return !isEnabled(feature); });
}

export var HISTORICAL_DATA_DAYS = 60;

export var ALL_FEATURES = [
	DIGITAL_EXERCISES,
	LOG_READING,
	INVITE_SPONSORS,
	AUTOGRADER_DATA,
	TEACHER_COMMENTS,
	TEXT_SPECIFIC_QUESTIONS,
	CLOZE_ASSESSMENTS,
	HISTORICAL_DATA,
	AUTOGRADED_ANSWERS,
	LEARNING_SERIES,
	STUDENT_DIFFERENTIATION,
	STANDARDS_CUSTOMIZATION,
	GROUP_INSIGHTS,
	TASK_ITEMS
];


// WEBPACK FOOTER //
// ./modules/lib/account/Features.js